import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import useRealOrderSearch from './hooks/useRealOrderSearch/useRealOrderSearch'
import RealOrderOption from './RealOrderOption/RealOrderOption'
import * as Styles from './styles'

const RealOrderSettings = ({ storeId, timeZone, selectedRealOrderId, selectedRealOrderName, onSelectRealOrder }) => {
  const { t } = useTranslation()
  const { orders, searchingOrders, searchOrders } = useRealOrderSearch({ storeId })

  const orderOptions = orders?.map(order => {
    return {
      value: order.id,
      label: <RealOrderOption order={order} timeZone={timeZone} />,
    }
  })

  const handleChangeOrder = event => onSelectRealOrder(event.target.value)

  const renderSelectedOrder = () => {
    const selectedRealOrder = orders?.find(order => order.id === selectedRealOrderId)

    if (selectedRealOrder) return selectedRealOrder.name

    return selectedRealOrderName
  }

  return (
    <Styles.Container>
      <Styles.Intro>
        <Text type="titleM">{t('Pedido real')}</Text>
        <Styles.Description type="bodySRegular">
          {t(
            'Previsualiza cómo se ve hoy un pedido real. La página de seguimiento refleja el estado actual del pedido, incluidos los datos del cliente y los criterios de visibilidad.'
          )}
        </Styles.Description>
      </Styles.Intro>
      <ComboBox
        label={t('Buscar pedido')}
        value={selectedRealOrderId}
        menuItems={orderOptions}
        handleChange={handleChangeOrder}
        searchable
        searchPlaceholder={t('Buscar por número de pedido o email')}
        onSearchChange={searchOrders}
        loading={searchingOrders}
        renderSelectedValue={renderSelectedOrder}
        fullWidth
      />
    </Styles.Container>
  )
}

export default RealOrderSettings
